export const environment = {
  production: false,
  clientId: 'c43a654f-8f8a-40cd-a623-3b0337052fba',
  tenantId: 'd145d1f9-d198-4bfc-963d-1ebccb89af5b',
  baseAddressAPI: 'https://uat-salesfunction.azurewebsites.net',
  postLogoutUrl: 'https://uat-sales.quotedevil.ie',
  code: 'kPo33mkIh2PWRHtDtPE0wJDlgx3FGTQE3p4PnyRePwR61kyQ07IteQ==',
  brokerId: '04',
  onBoardingDocuments: {
    address: 'https://uat-onboardingfunctions.azurewebsites.net',
    code: 'n74c3hBIw7wpXwShh3qGZz381B80GlDyomG2xy0rjDslAzFucRRqTw==',
  },
  apiManagement: {
    address: 'https://apim-chill-motor-dev.azure-api.net/gs/',
    scopes: ['api://efca2a33-e30a-40c4-ab2d-895a78ad656b/.default'],
    subscriptionKey: '0623f68bf27e4f93aabb70e3683a3117'
  },
  onBoardingAPI: {
    address: 'https://dev-api.chill.ie',
    subscriptionKey: 'f1a68d74173240cb857cbd7c281b5544',
  }, hfqAPI: {
    address: 'https://ca-api-ingestion.calmriver-196c4e97.northeurope.azurecontainerapps.io/',
    subscriptionKey: 'f1a68d74173240cb857cbd7c281b5544',
  },rssAPI: {
    address: 'https://ca-api-ingestion.niceriver-8c84e7e9.northeurope.azurecontainerapps.io/',
    uploadFunctionAPI: 'https://uploadlicenses-uat.azurewebsites.net/',
    uploadFunctionAPICode: 'e2rhTwTjZwWk4kmhddBy5_e545TOa_qIXzwMEwGxpBsWAzFuxGjpPQ==',
      subscriptionKey: 'f1a68d74173240cb857cbd7c281b5544',
    },graphAPI: {
    address:
      'https://graph.microsoft.com/v1.0/groups/b5343b5d-81a2-4366-b798-44b6b6bbee6b/members',
  }
};
